import React, { Component, Context } from "react";
import { connect } from "react-redux";
import { Swipeable, EventData } from "react-swipeable";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { IAppActionDispatches, mapAppDispatchToProps } from "../../../redux/actions/app";
import { IAppState, mapAppStateToProps } from "../../../redux/reducers/app";
import { WidgetProps } from "..";
import { ISiteQuotesContent, IEditableWidget } from "../../../models/cms";
import { ISitePage } from "../../../laco-common/base/models/page";
import { UIUserAvatar } from "../../ui/UIUserAvatar";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import quotesIcon from "../../../assets/icons/Quotes.png";
import "./Quotes.scss";

type QuotesProps = IEditableWidget & {};

type QuotesState = {
	activeIndex: number;
	swipingIndex: number;
};

const QUOTES_PER_PAGE: number = 3;

class Quotes extends Component<IAppActionDispatches & IAppState & WidgetProps & QuotesProps, QuotesState> {
	static contextType: Context<ILayoutContext> = LayoutContext;
	private interval;
	private readonly page: ISitePage = this.props.page || this.props.activePage;
	private readonly cycleInterval: number =
		this.props.siteConfiguration && this.props.siteConfiguration.quotesCycleTime
			? this.props.siteConfiguration.quotesCycleTime * 1000
			: 5000;

	state = {
		activeIndex: 0,
		swipingIndex: undefined,
	};

	get quotesContent(): ISiteQuotesContent {
		const quotesContent =
			this.props.editWidget ||
			(this.props.quotesContent || []).find((c: ISiteQuotesContent) => c.id === this.page.id);
		if (!quotesContent) return (this.props.quotesContent || []).find((c: ISiteQuotesContent) => c.id === "home");
		return quotesContent;
		// return {
		// 	...quotesContent,
		// 	quotes: [...quotesContent.quotes, ...["quote 4", "quote 5", "quote 6"], "quote 7", "quote 8", "quote 9"],
		// 	quoters: [...quotesContent.quoters, ...quotesContent.quoters, ...quotesContent.quoters],
		// };
	}

	componentDidMount() {
		console.debug("siteConfiguration:", this.props.siteConfiguration);
		if (!this.props.editWidget) this.interval = setInterval(this.cycleItems.bind(this), this.cycleInterval);
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	cycleItems(step?: number) {
		if (!this.quotesContent || !this.quotesContent.quotes?.length || this.interval == undefined) return;
		// console.debug("cycleItems, interval:", this.interval);
		let nextIndex: number = this.state.activeIndex + 1 + (step || 0);
		if (
			nextIndex >= this.quotesContent.quotes?.length ||
			(this.context.settings.isLGRes &&
				nextIndex >= Math.round(this.quotesContent.quotes?.length / QUOTES_PER_PAGE))
		) {
			nextIndex = 0;
		} else if (nextIndex < 0) {
			nextIndex = this.quotesContent.quotes?.length - 1;
		}
		this.setState({ activeIndex: nextIndex });
	}

	pauseCycle() {
		console.debug("pauseCycle()");
		this.interval = undefined;
		clearInterval(this.interval);
		setTimeout(() => {
			if (this.interval === undefined) this.resumeCycle();
		}, 10000);
	}

	resumeCycle() {
		console.debug("resumeCycle()");
		clearInterval(this.interval);
		this.interval = setInterval(this.cycleItems.bind(this), this.cycleInterval);
		// setTimeout(() => {
		// 	this.interval = setInterval(this.cycleItems.bind(this), this.cycleInterval);
		// }, this.cycleInterval);
	}

	swiping(e: EventData, i: number) {
		this.pauseCycle();
		this.setState({ swipingIndex: i });
	}

	onSwiped(e: EventData, i: number) {
		this.setState({ swipingIndex: undefined });
		this.resumeCycle();
	}

	swipingLeft(e?: EventData, i?: number) {
		this.setState({ swipingIndex: undefined });
		this.cycleItems(-2); // ends up being -1
	}

	swipingRight(e?: EventData, i?: number) {
		this.setState({ swipingIndex: undefined });
		this.cycleItems();
	}

	render() {
		const content: ISiteQuotesContent = this.quotesContent;
		if (!content || !content.quotes?.length) return null;
		let { title, quotes, quoters, profileImages, locations } = content;
		// quotes = [...quotes, ...quotes, ...quotes];
		// quoters = [...quoters, ...quoters, ...quoters];
		// profileImages = [...profileImages, ...profileImages, ...profileImages];
		// locations = [...locations, ...locations, ...locations];
		const editable: boolean = !!this.props.editWidget;
		const { activeIndex } = this.state;
		// quotes = quotes.concat(quotes);
		const quotesLength: number = this.context.settings.isLGRes
			? Math.ceil(quotes?.length / QUOTES_PER_PAGE)
			: quotes?.length;
		const showArrows = quotesLength > 1;
		// console.log("quotesLength:", quotesLength);

		return (
			<div className="bg-gray1">
				<div
					className={clsx(
						!this.props.isNested && "container",
						!this.props.page.noPadding && "section-padding",
						"d-flex flex-column quotes-container"
					)}
				>
					<h1
						className={clsx("text-center", editable && "cms-editable-field")}
						contentEditable={editable}
						onBlur={this.props.onInput}
						data-cms-field="title"
					>
						{title}
					</h1>
					<div className={clsx("d-flex flex-row justify-content-center")}>
						{showArrows && (
							<IconButton
								className="align-self-center"
								aria-label="Back"
								color="inherit"
								onClick={() => this.swipingLeft()}
								style={{ marginLeft: "-25px" }}
							>
								<ChevronLeftIcon fontSize="large" color="primary" />
							</IconButton>
						)}

						{quotes?.map((q: string, i: number) => {
							return (
								<Swipeable
									key={i}
									className={clsx(
										this.context.settings.isLGRes ? "_w-25" : "w-75",
										"_w-100-xs animated mt-4_5 swipable-container align-self-center",
										!this.context.settings.isLGRes && this.state.activeIndex === i && "fadeIn",
										!this.context.settings.isLGRes &&
											this.state.activeIndex !== i &&
											"fadeOut d-none",
										this.context.settings.isLGRes &&
											i >= activeIndex * QUOTES_PER_PAGE &&
											i < (activeIndex + 1) * QUOTES_PER_PAGE &&
											"fadeIn", // 0 - 0,1,2,3   1 - 4,5,6,7
										this.context.settings.isLGRes &&
											(i % QUOTES_PER_PAGE === 0 ||
												i % (3 + QUOTES_PER_PAGE * activeIndex) === 0 ||
												i === quotes.length - 1) &&
											"align-self-end", // 0, 4, 8, 12, 3 , 7, 11
										this.context.settings.isLGRes &&
											(i < activeIndex * QUOTES_PER_PAGE ||
												i >= (activeIndex + 1) * QUOTES_PER_PAGE) &&
											"fadeOut d-none" // 0 - 0,1,2,3   1 - 4,5,6,7
									)}
									onSwiping={(e: EventData) => this.swiping(e, i)}
									onSwipedLeft={(e: EventData) => this.swipingLeft(e, i)}
									onSwipedRight={(e: EventData) => this.swipingRight(e, i)}
									onSwiped={(e: EventData) => this.onSwiped(e, i)}
								>
									<div
										className="quote-block d-flex flex-column align-items-center"
										onClick={
											editable
												? (e) => {
														e.preventDefault();
														e.stopPropagation();
												  }
												: () => this.cycleItems()
										}
										style={editable ? undefined : { cursor: "pointer" }}
										// onMouseEnter={(e) => {
										// 	if (editable) return;
										// 	e.preventDefault();
										// 	e.stopPropagation();
										// 	this.pauseCycle();
										// }}
										// onMouseOut={(e) => {
										// 	if (editable) return;
										// 	e.preventDefault();
										// 	e.stopPropagation();
										// 	this.resumeCycle();
										// }}
										key={i}
									>
										<div className="quoter-content d-flex flex-row align-items-center mb-4">
											<UIUserAvatar
												imageUrl={!!profileImages && !!profileImages[i] ? profileImages[i] : ""}
											/>
											<div className="text-left">
												{!!quoters && !!quoters[i] && (
													<span
														className={clsx(
															"quoter-name pb-0",
															editable && "cms-editable-field"
														)}
														contentEditable={editable}
														data-cms-field={`quoters[${i}]`}
														onBlur={this.props.onInput}
													>
														{quoters[i]}
													</span>
												)}
												{!!locations && !!locations[i] && (
													<div
														className={clsx(
															"location-text",
															editable && "cms-editable-field"
														)}
														contentEditable={editable}
														data-cms-field={`locations[${i}]`}
														onBlur={this.props.onInput}
													>
														{locations[i]}
													</div>
												)}
											</div>
										</div>

										<span
											className={clsx(
												"d-inline-block swipable-content",
												this.state.swipingIndex === i && "swiping"
											)}
										>
											<span
											// className={clsx(editable && "cms-editable-field")}
											>
												<span
													className={clsx(editable && "cms-editable-field", "quote-text")}
													contentEditable={editable}
													data-cms-field={`quotes[${i}]`}
													onBlur={this.props.onInput}
												>
													<img
														src={quotesIcon}
														className="d-inline-block"
														style={{ width: "35px", marginTop: "-38px" }}
													/>{" "}
													{q}
												</span>
											</span>
										</span>
									</div>
								</Swipeable>
							);
						})}

						{showArrows && (
							<IconButton
								className="align-self-center"
								aria-label="Next"
								color="inherit"
								onClick={() => this.swipingRight()}
								style={{ marginRight: "-25px" }}
							>
								<ChevronRightIcon fontSize="large" color="primary" />
							</IconButton>
						)}
					</div>
					{quotesLength > 1 && (
						<div className="text-center d-flex w-100 justify-content-center">
							{(this.context.settings.isLGRes
								? quotes.filter((q, i) => i < Math.ceil(quotes?.length / QUOTES_PER_PAGE))
								: quotes
							).map((q: string, i: number) => {
								return (
									<span
										onClick={() => this.setState({ activeIndex: i })}
										className={clsx("dot", this.state.activeIndex === i && "highlighted")}
										key={i}
									></span>
								);
							})}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default connect<IAppState, IAppActionDispatches, WidgetProps & QuotesProps>(
	mapAppStateToProps,
	mapAppDispatchToProps
)(Quotes);
